// ===========================================================================
// LOCAL DEBUG ONLY — gitignored, do NOT push.
// One floating panel with a 0–1 slider per gauge, for sanity-checking the fill
// animations. Self-activating: import this module once (locally, e.g. add
//   import "./app/path-to-mars/GaugeDebug";
// to js/index.js — don't commit it) and load the page with ?gaugeDebug.
// It reads the gauges off window.app.game, so no production code references it.
// ===========================================================================

function buildPanel(gauges) {
  const panel = document.createElement("div");
  panel.style.cssText =
    "position:fixed;top:12px;left:12px;z-index:99999;background:rgba(0,0,0,.8);" +
    "color:#fff;font:12px/1.4 monospace;padding:12px 14px;border-radius:8px;width:240px";

  gauges.forEach(([label, gauge]) => {
    const title = document.createElement("div");
    title.style.cssText = "font-weight:bold;margin:6px 0 4px";
    title.textContent = label;

    const row = document.createElement("label");
    row.style.cssText = "display:flex;align-items:center;gap:8px";
    const slider = document.createElement("input");
    slider.type = "range";
    slider.min = 0;
    slider.max = 1;
    slider.step = 0.01;
    slider.value = gauge.level ?? 0;
    slider.style.flex = "1";
    const val = document.createElement("span");
    val.style.cssText = "flex:0 0 36px;text-align:right";
    val.textContent = Number(slider.value).toFixed(2);

    slider.addEventListener("input", () => {
      const v = parseFloat(slider.value);
      val.textContent = v.toFixed(2);
      gauge.setLevel(v);
    });

    row.append(slider, val);
    panel.append(title, row);
  });

  document.body.appendChild(panel);
}

function init() {
  if (!new URLSearchParams(window.location.search).has("gaugeDebug")) return;
  const tryAttach = () => {
    const game = window.app && window.app.game;
    if (!game) return setTimeout(tryAttach, 200);
    const gauges = [
      ["Fuel", game.fuelGauge],
      ["Speed", game.speedGauge],
    ].filter(([, g]) => g && g.el);
    if (gauges.length) buildPanel(gauges);

    // Reveal the hidden centerlines (magenta) so they can be tuned against the
    // visible track. Edit the .gauge-centerline `d` in game-frame.twig.html until the
    // line traces the centre of the gauge, then it's done (stroke=none in prod).
    document.querySelectorAll(".gauge-centerline").forEach((p) => {
      p.setAttribute("stroke", "magenta");
      p.setAttribute("stroke-width", "2");
    });
  };
  tryAttach();
}

init();
